import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
// import './MasterHistory.css';

const MasterHistory = () => {
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [eventTypeId, setEventTypeId] = useState('0');

    const fetchHistories = async (page = 1, limit = 25, eventType = '0') => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `https://masterpg.9xxbet.com/api/v1/master/getmasterhisotry?page=${page}&limit=${limit}&eventTypeId=${eventType}`
            );
            const result = await response.json();

            if (result.success) {
                setData(result.data);
                setPagination(result.pagination);
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError(err.message || 'Failed to fetch data');
            console.error('Error:', err);
        } finally {
            setLoading(false);
        }
    };

    // Initial load and when page/pageSize changes
    useEffect(() => {
        fetchHistories(currentPage, pageSize, eventTypeId);
    }, [currentPage, pageSize, eventTypeId]);

    const handleNextPage = () => {
        if (pagination.hasNextPage) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (pagination.hasPrevPage) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageSizeChange = (e) => {
        setPageSize(parseInt(e.target.value));
        setCurrentPage(1);
    };

    const handleEventTypeChange = (e) => {
        setEventTypeId(e.target.value);
        setCurrentPage(1);
    };

    const handleFirstPage = () => {
        setCurrentPage(1);
    };

    const handleLastPage = () => {
        setCurrentPage(pagination.totalPages);
    };

    // Get status badge color based on winner
    const getWinnerBadge = (winnerId, winnerName) => {
        if (winnerId) {
            return (
                <span className="badge bg-success">
                    <i className="bi bi-check-circle"></i> {winnerId + " " + (winnerName != 'undefined' || "")}
                </span>
            );
        }
        return <span className="badge bg-secondary">No Winner</span>;
    };

    const rollbackAll = async (record, mid) => {
        if (window.confirm(`Are you sure want to rollback ${record.marketName} of ${record.eventName}`)) {
            if (window.confirm(`Are you sure want to rollback ${record.marketName} of ${record.eventName}`)) {
                try { rollBackMidMaster(mid) } catch (error) { }
                try { rollBackMidHero(mid) } catch (error) { }
                try { rollBackBest(mid) } catch (error) { }
            }
        }

    }

    const rollBackMidMaster = async (mid) => {
        const res = await fetch('https://masterpg.9xxbet.com/api/v1/result/rollbackmarket?mid=' + mid)
        const data = await res.json()
        toast.success("rollback updated to MASTERSERVER")
        return data
    }

    const rollBackMidHero = async (mid) => {
        const res = await fetch('https://postg.9xxbet.com/api/v1/result/rollbackmarket?mid=' + mid)
        const data = await res.json()
        toast.success("rollback updated to Maagic")
        return data
    }

    const rollBackBest = async (mid) => {
        const res = await fetch('https://webapi.demoxyzapi.com/api/v1/result/rollbackmarket?mid=' + mid)
        const data = await res.json()
        toast.success("rollback updated to KIT")
        return data
    }

    return (
        <div className="master-history-container">
            {/* Header Section */}
            <div className="header-section mb-4">
                <div className="container-fluid">
                    <h1 className="page-title">
                        <i className="bi bi-clock-history"></i> Master History
                    </h1>
                    <p className="page-subtitle">Browse and manage market events history</p>
                </div>
            </div>

            <div className="container-fluid px-4 py-4">
                {/* Filters Section */}
                <div className="filters-section mb-4">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="filter-group">
                                <label htmlFor="pageSizeSelect" className="form-label fw-600">
                                    Records Per Page
                                </label>
                                <select
                                    id="pageSizeSelect"
                                    className="form-select form-select-lg"
                                    value={pageSize}
                                    onChange={handlePageSizeChange}
                                >
                                    {/* <option value={5}>5 Records</option>
                                    <option value={10}>10 Records</option> */}
                                    <option value={25}>25 Records</option>
                                    {/* <option value={50}>50 Records</option> */}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Error Alert */}
                {error && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <i className="bi bi-exclamation-circle"></i>
                        <strong> Error!</strong> {error}
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setError(null)}
                        ></button>
                    </div>
                )}

                {/* Loading State */}
                {loading && (
                    <div className="loading-container">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2 text-muted">Fetching latest market data...</p>
                    </div>
                )}

                {/* Data Table */}
                {!loading && data.length > 0 && (
                    <>
                        <div className="table-wrapper">
                            <div className="table-header">
                                {/* <h5 className="mb-0">
                                    <i className="bi bi-table"></i> Market Events
                                </h5> */}
                                {/* <span className="badge bg-primary">
                                    {pagination.totalRecords} Total Records
                                </span> */}
                            </div>

                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="col-id">
                                                <i className="bi bi-hash"></i> ID
                                            </th>
                                            <th scope="col" className="col-event">
                                                <i className="bi bi-calendar-event"></i> Event Name
                                            </th>
                                            <th scope="col" className="col-market">
                                                <i className="bi bi-graph-up"></i> Market Name
                                            </th>
                                            <th scope="col" className="col-type">
                                                <i className="bi bi-tag"></i> Event Type
                                            </th>
                                            <th scope="col" className="col-winner">
                                                <i className="bi bi-trophy"></i> Winner
                                            </th>
                                            <th scope="col" className="col-winner">
                                                <i className="bi bi-trophy"></i> Rollback
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((record, index) => (
                                            <tr key={record.id} className="table-row-hover">
                                                <td className="col-id">
                                                    <span className="badge bg-light text-dark">
                                                        {record.id}
                                                    </span>
                                                </td>
                                                <td className="col-event">
                                                    <div className="event-cell">
                                                        <p className="cell-main-text mb-0">
                                                            {record.eventName || 'N/A'}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td className="col-market">
                                                    <div className="market-cell">
                                                        <p className="cell-main-text mb-0">
                                                            {record.marketName || 'N/A'}
                                                        </p>
                                                        <small className="cell-sub-text">
                                                            Type: {record.marketType || 'Unknown'}
                                                        </small>
                                                    </div>
                                                </td>
                                                <td className="col-type">
                                                    <span className="badge bg-info">
                                                        {record.eventTypeName || 'Unknown'}
                                                    </span>
                                                </td>
                                                <td className="col-winner">
                                                    {record.winnerId + " " + (record.eventTypeId != '0' ? record.winnerName : "")}
                                                </td>
                                                <td>
                                                    <button onClick={() => {
                                                        rollbackAll(record, record.marketId)
                                                    }} className='btn btn-primary'>
                                                        Rollback
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Pagination Section */}
                        <div className="pagination-section mt-4">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <div className="pagination-info">
                                        <p className="mb-0">
                                            Showing <strong>{(currentPage - 1) * pageSize + 1}</strong> to{' '}
                                            <strong>
                                                {Math.min(currentPage * pageSize, pagination.totalRecords)}
                                            </strong>{' '}
                                            of <strong>{pagination.totalRecords}</strong> records
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <nav aria-label="Page navigation">
                                        <ul className="pagination justify-content-end mb-0">
                                            <li className={`page-item ${!pagination.hasPrevPage ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={handleFirstPage}
                                                    disabled={!pagination.hasPrevPage}
                                                >
                                                    <i className="bi bi-chevron-double-left"></i> First
                                                </button>
                                            </li>
                                            <li className={`page-item ${!pagination.hasPrevPage ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={handlePrevPage}
                                                    disabled={!pagination.hasPrevPage}
                                                >
                                                    <i className="bi bi-chevron-left"></i> Previous
                                                </button>
                                            </li>
                                            <li className="page-item active">
                                                <span className="page-link">
                                                    Page {pagination.currentPage}
                                                </span>
                                            </li>
                                            <li className={`page-item ${!pagination.hasNextPage ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={handleNextPage}
                                                    disabled={!pagination.hasNextPage}
                                                >
                                                    Next <i className="bi bi-chevron-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Empty State */}
                {!loading && data.length === 0 && !error && (
                    <div className="empty-state">
                        <div className="empty-state-icon">
                            <i className="bi bi-inbox"></i>
                        </div>
                        <h4>No Data Found</h4>
                        <p>No market histories available for the selected filters.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MasterHistory;